import { createFileRoute, notFound } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { getCalculator } from "@/tools/bmi-calculator/calculators";
import { CalculatorPage } from "@/tools/bmi-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/bmi-calculator/$calc")({
  ssr: true,
  loader: ({ params }) => {
    if (!getCalculator(params.calc)) throw notFound();
  },
  head: ({ params }) => {
    const def = getCalculator(params.calc);
    if (!def) return {};
    return {
      meta: [
        { title: def.metaTitle() },
        { name: "description", content: def.metaDescription() },
        { property: "og:title", content: def.metaTitle() },
        { property: "og:description", content: def.metaDescription() },
        ...i18nOgMeta(def.path),
      ],
      links: [...i18nLinks(def.path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: m.bmi_breadcrumb_home(),
                item: localeUrl(`/`),
              },
              {
                "@type": "ListItem",
                position: 2,
                name: m.bmi_tool_name(),
                item: localeUrl(`/bmi-calculator`),
              },
              {
                "@type": "ListItem",
                position: 3,
                name: def.navName(),
                item: localeUrl(`${def.path}`),
              },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: def.faqs.map((f) => ({
              "@type": "Question",
              name: f.q(),
              acceptedAnswer: { "@type": "Answer", text: f.a() },
            })),
          }),
        },
      ],
    };
  },
  component: CalcRoute,
});

function CalcRoute() {
  const { calc } = Route.useParams();
  const def = getCalculator(calc);
  if (!def) return null;
  return <CalculatorPage def={def} />;
}
